import React from 'react';
import { useIntl } from 'react-intl';
import SegmentIcon from 'components/SegmentIcon';
import Table from 'components/Table';
import { fraction } from 'shared/constants/math';
import { getFilterSummaryDate } from './formatters';
import { getUniqueValues } from './utils';
import ChartToolbox from './ChartToolbox';
import messages from './messages';

function getColumns({ segments, formatMessage, showAsPercentage, locale }) {
  const columns = [{
    dataIndex: 'category',
    title: formatMessage(messages.option),
  }];

  segments.filter(s => !s.isBenchmark).forEach((s, i) => {
    let column = columns.find(c => c.title === s.name);
    if (!column) {
      column = { title: s.name, children: [] };
      columns.push(column);
    }

    column.children.push({
      dataIndex: i,
      title: (
        <>
          <SegmentIcon segment={s} />
          {`(${formatMessage(messages.responseCount, { count: s.uniqueCount })}) ${getFilterSummaryDate(s, locale)}`}
        </>
      ),
      type: showAsPercentage ? 'percent' : 'number',
      align: 'left',
    });
  });

  return columns;
}

function getData({ segments, showAsPercentage }) {
  const formattedValue = (value, total) => {
    if (showAsPercentage) {
      return fraction(value, total);
    }
    return value;
  };

  let dataSource = [];
  if (segments.length) {
    // Add the first segment and define the data.
    dataSource = getUniqueValues(segments).map(v => ({
      id: v.id,
      category: v.name,
    }));

    // Add other segment values to the data
    segments.filter(s => !s.isBenchmark).forEach((segment, index) => {
      dataSource.forEach((d, i) => {
        const segmentValue = segment.values.find(v => v.id === d.id);
        if (segmentValue) {
          dataSource[i][index] = formattedValue(segmentValue.value, segment.uniqueCount);
        }
      });
    });
  }
  return dataSource;
}

const DataTable = ({ segments, isScoreGraph, toolbox, chartSettings = {} }) => {
  const { formatMessage, locale } = useIntl();
  const { displayMode } = chartSettings;

  const showAsPercentage = displayMode === 'percentage' && !isScoreGraph;

  const columns = getColumns({ segments, formatMessage, showAsPercentage, locale });

  const dataSource = getData({ segments, showAsPercentage });

  return (
    <>
      <Table
        className="chart__data-view"
        bordered
        size="middle"
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        // scroll={{ x: true }}
        interactive={false}
      />
      {toolbox && <ChartToolbox {...chartSettings} {...toolbox} hasData />}
    </>
  );
};

export default DataTable;
